"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationInitiationClientDataInternal = void 0;
const core = __importStar(require("../../core"));
const ConversationConfigClientOverrideOutput_1 = require("./ConversationConfigClientOverrideOutput");
const ConversationInitiationClientDataInternalDynamicVariablesValue_1 = require("./ConversationInitiationClientDataInternalDynamicVariablesValue");
exports.ConversationInitiationClientDataInternal = core.serialization.object({
    conversationConfigOverride: core.serialization.property("conversation_config_override", ConversationConfigClientOverrideOutput_1.ConversationConfigClientOverrideOutput.optional()),
    customLlmExtraBody: core.serialization.property("custom_llm_extra_body", core.serialization.record(core.serialization.string(), core.serialization.unknown()).optional()),
    userId: core.serialization.property("user_id", core.serialization.string().optional()),
    dynamicVariables: core.serialization.property("dynamic_variables", core.serialization
        .record(core.serialization.string(), ConversationInitiationClientDataInternalDynamicVariablesValue_1.ConversationInitiationClientDataInternalDynamicVariablesValue.optional())
        .optional()),
});
